import {RRule} from 'rrule';

const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const rule1 = new RRule({
  freq: RRule.WEEKLY,
  byweekday: [RRule.MO, RRule.WE],
  dtstart: new Date("2025-04-16T15:00:00-07:00"),
  until: new Date("2025-08-04T16:00:00-07:00"),
});

const rule2 = new RRule({
  freq: RRule.WEEKLY,
  byweekday: [RRule.TU, RRule.TH],
  dtstart: new Date("2025-04-17T15:00:00-07:00"),
  until: new Date("2025-05-08T16:00:00-07:00"),
});

const rule3 = new RRule({
  freq: RRule.WEEKLY,
  byweekday: [RRule.SA],
  dtstart: new Date("2025-04-26T11:00:00-07:00"),
  until: new Date("2025-06-07T12:00:00-07:00"),
});

const rule4 = new RRule({
  freq: RRule.WEEKLY,
  byweekday: [RRule.SA],
  dtstart: new Date("2025-04-26T14:00:00-07:00"),
  until: new Date("2025-05-31T15:00:00-07:00"),
});

const dates1 = rule1.all();
const dates2 = rule2.all();
const dates3 = rule3.all();
const dates4 = rule4.all();

const skipDate3 = new Date("2025-05-17T11:00:00-07:00");
const skipDate4 = new Date("2025-05-17T14:00:00-07:00");

const recurringEvent1 = dates1.map(date => (
  {
    title: "Mastering Smart Manufacturing: AI, IoT & Cyber-Physical Systems",
    start: date,
    end: new Date(date.getTime() + 60 * 60 * 1000), // 1 hr duration
    dateTime: `${weekdays[new Date(date).getDay()]}, ${monthNames[new Date(date).getMonth()]} ${new Date(date).getDate()} · 3 - 4pm PDT`,
    description: "Get ready to dive into the world of Smart Manufacturing with AI, IoT, and Cyber-Physical Systems at our event!",
    url: "https://www.eventbrite.ca/e/mastering-smart-manufacturing-ai-iot-cyber-physical-systems-tickets-1289375730519?aff=ebdsoporgprofile"
  }
))

const recurringEvent2 = dates2.map(date => (
  {
    title: "Precision Agriculture: Smart AgTech for Canadian Sustainability",
    start: date,
    end: new Date(date.getTime() + 60 * 60 * 1000), // 1 hr duration
    dateTime: `${weekdays[new Date(date).getDay()]}, ${monthNames[new Date(date).getMonth()]} ${new Date(date).getDate()} · 3 - 4pm PDT`,
    description: "Learn about the latest technologies in agriculture and how they're shaping a sustainable future for Canada!",
    url: "https://www.eventbrite.ca/e/precision-agriculture-smart-agtech-for-canadian-sustainability-tickets-1220383894079?aff=ebdsoporgprofile"
  }
))

const recurringEvent3 = dates3.filter(date => date.toISOString() !== skipDate3.toISOString()).map(date => (
  {
    title: "Canada's Green Economy & AI: Shaping a Sustainable Future with AI",
    start: date,
    end: new Date(date.getTime() + 60 * 60 * 1000), // 1 hr duration
    dateTime: `${weekdays[new Date(date).getDay()]}, ${monthNames[new Date(date).getMonth()]} ${new Date(date).getDate()} · 11am - 12pm PDT`,
    description: "Join us to explore how AI is driving Canada's green economy towards a sustainable future!",
    url: "https://www.eventbrite.ca/e/canadas-green-economy-ai-shaping-a-sustainable-future-with-ai-tickets-1278527693749?aff=ebdsoporgprofile"
  }
))

const recurringEvent4 = dates4.filter(date => date.toISOString() !== skipDate4.toISOString()).map(date => (
  {
    title: "Intro to Python Series",
    start: date,
    end: new Date(date.getTime() + 60 * 60 * 1000), // 1 hr duration
    dateTime: `${weekdays[new Date(date).getDay()]}, ${monthNames[new Date(date).getMonth()]} ${new Date(date).getDate()} · 2 - 3pm PDT`,
    description: "Kickstart your coding journey with Python! Join our 11-week series and learn coding fundamentals, data structures, and more!",
    url: "https://www.eventbrite.ca/e/intro-to-python-series-tickets-1269560612969?aff=ebdsoporgprofile"
  }
))

const oneTimeEvents = [
  {
    // id: 1,
    title: "Canada's Green Economy & AI: Shaping a Sustainable Future with AI",
    start: new Date(2025, 3, 26, 11, 0, 0),
    end: new Date(2025, 3, 26, 12, 0, 0),
    dateTime: "Saturday, April 26 · 11am - 12pm PDT",
    description: "Join us to explore how AI is driving Canada's green economy towards a sustainable future!",
    url: "https://www.eventbrite.ca/e/canadas-green-economy-ai-shaping-a-sustainable-future-with-ai-tickets-1278527693749?aff=ebdsoporgprofile"
  },
  // {
  //   id: 2,
  //   title: "Mastering Smart Manufacturing: AI, IoT & Cyber-Physical Systems",
  //   start: new Date(2025, 3, 16, 15, 0, 0),
  //   end: new Date(2025, 3, 16, 16, 0, 0),
  //   dateTime: "Wednesday, April 16 · 3 - 4pm PDT",
  //   description: "Get ready to dive into the world of Smart Manufacturing with AI, IoT, and Cyber-Physical Systems at our event!",
  //   url: "https://www.eventbrite.ca/e/mastering-smart-manufacturing-ai-iot-cyber-physical-systems-tickets-1289375730519?aff=ebdsoporgprofile"
  // },
  // {
  //   // id: 3,
  //   title: "Intro to Python Series",
  //   start: new Date(2025, 3, 26, 14, 0, 0),
  //   end: new Date(2025, 3, 26, 13, 0, 0),
  //   dateTime: "Saturday, April 26 · 2 - 3pm PDT",
  //   description: "Kickstart your coding journey with Python! Join our 11-week series and learn coding fundamentals, data structures, and more!",
  //   url: "https://www.eventbrite.ca/e/intro-to-python-series-tickets-1269560612969?aff=ebdsoporgprofile"
  // },
  // {
  //   // id: 4,
  //   title: "Precision Agriculture: Smart AgTech for Canadian Sustainability",
  //   start: new Date(2025, 3, 17, 15, 0, 0),
  //   end: new Date(2025, 3, 17, 16, 0, 0),
  //   dateTime: "Thursday, April 17 · 3 - 4pm PDT",
  //   description: "Learn about the latest technologies in agriculture and how they're shaping a sustainable future for Canada!",
  //   url: "https://www.eventbrite.ca/e/precision-agriculture-smart-agtech-for-canadian-sustainability-tickets-1220383894079?aff=ebdsoporgprofile"
  // },
];

export const EventCalendarData = oneTimeEvents
  .concat(recurringEvent1)
  .concat(recurringEvent2)
  .concat(recurringEvent3)
  .concat(recurringEvent4)